export async function getEnv(name, defaultValue) {
  await window.tycom._initConfigPromise;
  return window.tycom.configCenter.getEnv(name, {
    defaultValue,
  });
}
